module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "shopService"
    }
  }, [_c('el-row', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-col', {
    staticClass: "fl",
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.backGo()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    attrs: {
      "span": 1
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fl searthPart",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('p', {
    staticClass: "headerT fl",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("工单信息")]), _vm._v(" "), _c('el-button', {
    staticClass: "fl",
    staticStyle: {
      "margin": "-5px 0 0 0px"
    },
    attrs: {
      "size": "small",
      "type": "danger"
    }
  }, [_vm._v("待确认")]), _vm._v(" "), _c('el-button', {
    staticClass: "fl",
    staticStyle: {
      "margin": "-5px 0 0 20px"
    },
    attrs: {
      "size": "small",
      "type": "danger"
    }
  }, [_vm._v("未指派工程师")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-star-off fl",
    class: {
      'StarOn': _vm.highStar
    },
    staticStyle: {
      "font-size": "20px",
      "margin-left": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.dolikes()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('el-form', {
    ref: "orderInfoForm",
    attrs: {
      "model": _vm.orderInfoForm,
      "label-width": "120px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工单编号"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.orderNumber),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "orderNumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.orderNumber"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.orderInfoForm.orderNumber, $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.orderInfoForm.afterSalesNum !== 0) ? _c('el-form-item', {
    attrs: {
      "label": "原始工单"
    }
  }, [_c('div', {
    staticClass: "fl falseInput",
    on: {
      "click": function($event) {
        return _vm.gotoService()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.orderInfoForm.olderOrderCode) + "\n          "), _c('span', {
    staticClass: "fr falseSpan"
  }, [_vm._v("\n            售后数:" + _vm._s(_vm.orderInfoForm.afterSalesNum) + "\n          ")])]), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.orderInfoForm.olderOrderCode, $event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工单类型",
      "prop": "orderType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择工单类型"
    },
    model: {
      value: (_vm.orderInfoForm.orderType),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "orderType", $$v)
      },
      expression: "orderInfoForm.orderType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "上门维修",
      "value": "orderType001"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "上门售后",
      "value": "orderType002"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "到店维修",
      "value": "orderType003"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "到店售后",
      "value": "orderType004"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "渠道来源",
      "prop": "orderSource"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择渠道来源"
    },
    model: {
      value: (_vm.orderInfoForm.orderSource),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "orderSource", $$v)
      },
      expression: "orderInfoForm.orderSource"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "电话",
      "value": "eeww"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "微信",
      "value": "rere"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "微博",
      "value": "hghg"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户姓名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderInfoForm.clientName),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "clientName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.clientName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderInfoForm.clientPhone),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "clientPhone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.clientPhone"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.orderInfoForm.clientPhone, $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省市区"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "placeholder": "省级地区"
    },
    on: {
      "change": _vm.choseProvince
    },
    model: {
      value: (_vm.sheng),
      callback: function($$v) {
        _vm.sheng = $$v
      },
      expression: "sheng"
    }
  }, _vm._l((_vm.province), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.value,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "28%"
    },
    attrs: {
      "placeholder": "市级地区"
    },
    on: {
      "change": _vm.choseCity
    },
    model: {
      value: (_vm.shi),
      callback: function($$v) {
        _vm.shi = $$v
      },
      expression: "shi"
    }
  }, _vm._l((_vm.shi1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.value,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "28%"
    },
    attrs: {
      "placeholder": "区级地区"
    },
    on: {
      "change": _vm.choseBlock
    },
    model: {
      value: (_vm.qu),
      callback: function($$v) {
        _vm.qu = $$v
      },
      expression: "qu"
    }
  }, _vm._l((_vm.qu1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.value,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderInfoForm.clientAddress),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "clientAddress", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.clientAddress"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.sheng + _vm.shi + _vm.qu + _vm.orderInfoForm.clientAddress, $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.orderInfoForm.appoTime),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "appoTime", $$v)
      },
      expression: "orderInfoForm.appoTime"
    }
  }), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "28%"
    },
    attrs: {
      "placeholder": "起始时间",
      "picker-options": {
        start: '08:30',
        step: '02:00',
        end: '18:30'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "28%"
    },
    attrs: {
      "placeholder": "结束时间",
      "picker-options": {
        start: '08:30',
        step: '02:00',
        end: '18:30',
        minTime: _vm.startTime
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "headerT"
  }, [_vm._v("维修信息")]), _vm._v(" "), _c('el-form', {
    ref: "orderInfoForm",
    attrs: {
      "model": _vm.orderInfoForm,
      "label-width": "120px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "IMEI",
      "prop": "IMEI"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.IMEI),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "IMEI", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.IMEI"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌",
      "prop": "brand"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择渠道来源"
    },
    model: {
      value: (_vm.orderInfoForm.brand),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "brand", $$v)
      },
      expression: "orderInfoForm.brand"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "电话",
      "value": "eeww"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "微信",
      "value": "rere"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "微博",
      "value": "hghg"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品类",
      "prop": "category"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择品类"
    },
    model: {
      value: (_vm.orderInfoForm.category),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "category", $$v)
      },
      expression: "orderInfoForm.category"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "电话",
      "value": "eeww"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "微信",
      "value": "rere"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "微博",
      "value": "hghg"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "型号",
      "prop": "model"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择型号"
    },
    model: {
      value: (_vm.orderInfoForm.model),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "model", $$v)
      },
      expression: "orderInfoForm.model"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "电话",
      "value": "eeww"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "微信",
      "value": "rere"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "微博",
      "value": "hghg"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "颜色",
      "prop": "color"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择颜色"
    },
    model: {
      value: (_vm.orderInfoForm.color),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "color", $$v)
      },
      expression: "orderInfoForm.color"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "红色",
      "value": "eeww"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "黄色",
      "value": "rere"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "黑色",
      "value": "hghg"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "故障分类",
      "prop": "faultClass"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.faultClassCheckList),
      callback: function($$v) {
        _vm.faultClassCheckList = $$v
      },
      expression: "faultClassCheckList"
    }
  }, [_c('el-checkbox', {
    staticStyle: {
      "width": "50%",
      "margin": "0"
    },
    attrs: {
      "label": "故障分类1",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "width": "50%",
      "margin": "0"
    },
    attrs: {
      "label": "故障分类2",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "width": "50%",
      "margin": "0"
    },
    attrs: {
      "label": "故障分类3",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "width": "50%",
      "margin": "0"
    },
    attrs: {
      "label": "故障分类4",
      "name": "type"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "故障",
      "prop": "fault"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.faultCheckList),
      callback: function($$v) {
        _vm.faultCheckList = $$v
      },
      expression: "faultCheckList"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "故障1",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "故障2",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "故障3",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "故障4",
      "name": "type"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "headerT"
  }, [_vm._v("支付信息")]), _vm._v(" "), _c('el-form', {
    ref: "orderInfoForm",
    attrs: {
      "model": _vm.orderInfoForm,
      "label-width": "120px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "故障金额",
      "prop": "faultPrice"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.orderInfoForm.faultPrice),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "faultPrice", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderInfoForm.faultPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "折扣",
      "prop": "discount"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择折扣"
    },
    model: {
      value: (_vm.orderInfoForm.discount),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "discount", $$v)
      },
      expression: "orderInfoForm.discount"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "95折",
      "value": "95"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "9折",
      "value": "90"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "85折",
      "value": "85"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应付金额",
      "prop": "sum"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "85%",
      "background-color": "#f5f7fa",
      "border-color": "#e4e7ed",
      "color": "#c0c4cc",
      "cursor": "not-allowed",
      "border-radius": "4px",
      "border": "1px solid #dcdfe6",
      "padding-left": "10px"
    },
    model: {
      value: (_vm.orderInfoForm.sum),
      callback: function($$v) {
        _vm.$set(_vm.orderInfoForm, "sum", $$v)
      },
      expression: "orderInfoForm.sum"
    }
  }, [_vm._v(_vm._s(Math.round(_vm.orderInfoForm.discount / 100 * _vm.orderInfoForm.faultPrice)))])])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    staticStyle: {
      "width": "62%"
    }
  }, [_c('el-button-group', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, _vm._l((_vm.orderStates), function(item, index) {
    return _c('el-button', {
      key: index,
      class: {
        activeBtn: _vm.activeBtnIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.changeState(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name) + "\n        "), (_vm.workorderReply.length !== 0 && index == 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.workorderReply.length) + ")")]) : _vm._e()])
  }), 1), _vm._v(" "), (_vm.activeBtnIndex == 0) ? _c('el-card', {
    staticClass: "box-card fr",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('ul', _vm._l((_vm.workorderReply), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "replyLi"
    }, [_c('el-row', [_c('el-col', {
      staticStyle: {
        "width": "75px"
      },
      attrs: {
        "span": 4
      }
    }, [_c('span', {
      staticClass: "headPic",
      class: {
        headUser1: item.replyer === 1,
        headUser2: item.replyer === -1
      }
    })]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 18
      }
    }, [(item.replyer === 1) ? _c('span', {
      staticClass: "fl"
    }, [_vm._v("客服")]) : _vm._e(), _vm._v(" "), (item.replyer === -1) ? _c('span', {
      staticClass: "fl"
    }, [_vm._v("工程师")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "createUser fl"
    }, [_vm._v(_vm._s(item.createUser))]), _vm._v(" "), (item.createTime) ? _c('span', {
      staticClass: "createTime childSpan clearfix"
    }, [_c('i', {
      staticClass: "fl"
    }), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm.formatTime(item.createTime)))]), _c('br')]) : _vm._e(), _vm._v(" "), (item.details) ? _c('span', {
      staticClass: "details childSpan"
    }, [_vm._v(_vm._s(item.details)), _c('br')]) : _vm._e()]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "position": "relative",
        "height": "80px"
      },
      attrs: {
        "span": 2
      }
    }, [_c('el-button', {
      staticStyle: {
        "position": "absolute",
        "bottom": "0",
        "margin-left": "10px"
      },
      attrs: {
        "size": "small",
        "type": "danger"
      }
    }, [_vm._v("删除回复")])], 1)], 1)], 1)
  }), 0), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeBtnIndex == 1) ? _c('el-row', [_c('ul', _vm._l((_vm.workOrderEvent), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "eventLi"
    }, [(item.createTime) ? _c('span', {
      staticClass: "createTime childSpan clearfix"
    }, [_c('i', {
      staticClass: "fl"
    }), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm.formatTime(item.createTime)))]), _c('br')]) : _vm._e(), _vm._v(" "), (item.details) ? _c('span', {
      staticClass: "details childSpan"
    }, [_vm._v(_vm._s(item.details)), _c('br')]) : _vm._e(), _vm._v(" "), (item.attribute1) ? _c('span', {
      staticClass: "attribute1 childSpan"
    }, [_vm._v("\n            " + _vm._s(item.attribute1.substring(0, item.attribute1.lastIndexOf('：') + 1)) + "\n            "), _c('span', {
      staticClass: "orderId"
    }, [_vm._v("\n            " + _vm._s(item.attribute1.substring(item.attribute1.lastIndexOf('：') + 1 )) + "\n            ")]), _c('br')]) : _vm._e(), _vm._v(" "), (item.attribute2) ? _c('span', {
      staticClass: "attribute2 childSpan"
    }, [_vm._v("\n            " + _vm._s(item.attribute2.substring(0, item.attribute2.lastIndexOf('：') + 1)) + "\n            "), _c('span', {
      staticClass: "orderId"
    }, [_vm._v("\n            " + _vm._s(item.attribute2.substring(item.attribute2.lastIndexOf('：') + 1 )) + "\n            ")]), _c('br')]) : _vm._e(), _vm._v(" "), (item.attribute3) ? _c('span', {
      staticClass: "attribute3 childSpan"
    }, [_vm._v("\n            " + _vm._s(item.attribute3.substring(0, item.attribute3.lastIndexOf('：') + 1)) + "\n            "), _c('span', {
      staticClass: "orderId"
    }, [_vm._v("\n            " + _vm._s(item.attribute3.substring(item.attribute3.lastIndexOf('：') + 1 )) + "\n            ")]), _c('br')]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('el-dropdown', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 0"
    },
    attrs: {
      "split-button": "",
      "type": "primary",
      "trigger": "click"
    }
  }, [_vm._v("\n      提交为\n      "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.DetermineSave()
      }
    }
  }, [_vm._v("已确认")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.temporarySave()
      }
    }
  }, [_vm._v("暂存")])], 1)], 1), _vm._v(" "), _c('el-dropdown', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "split-button": "",
      "type": "primary",
      "trigger": "click"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.pageStatus) + "\n      "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.goOnSave()
      }
    }
  }, [_vm._v("留在当前页面")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeSave()
      }
    }
  }, [_vm._v("离开当前页面")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-6fc25e7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/workOrder/shopService.vue
// module id = 1711
// module chunks = 0